module.exports = __webpack_public_path__ + "static/Rahil.f37e8b21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Rahil.jpg
// module id = 1319
// module chunks = 137408898365125